import * as React from 'react'
import { Button } from 'reactstrap'

export interface IBtnSelectOption {
  value: string;
  label?: string;
  nodes?: any[]
}

export interface IBtnSelectOptGroup {
  label: string;
  nodes: IBtnSelectOption[]
}

export interface IBtnSelectProps {
  header: string | JSX.Element
  disableBoldHeader?: boolean
  persistLabel?: boolean;
  hideSelectedValue?: boolean;
  color?: string;
  options?: IBtnSelectOption[]
  groupOptions?: IBtnSelectOptGroup[]
  disabled?: boolean
  clearable?: boolean
  clearLabel?: string
  value?: string
  defaultValue?: string
  useMobileMode?: boolean
  onChange?: (value: string, label: string) => void
  showSpinner?: boolean
  onClear?: () => void
  displayAllOption?: boolean
  displayNext?: boolean
  showAllCoachingFormOption?: boolean
}

// tslint:disable-next-line:no-empty-interface
interface IBtnSelectState {
  disabled?: boolean
}

export class BtnSelect extends React.Component<IBtnSelectProps, IBtnSelectState> {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.disabled !== prevState.disabled) {
      return { disabled: nextProps.disabled };
    } else { return null; }
  }

  state: IBtnSelectState = {}

  hasLoaded = false
  removePopoverIn2SecTimeout: number

  constructor(props) {
    super(props)
    this.checkForDefaultValue()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.disabled !== this.props.disabled) {
      this.checkForDefaultValue(this.props)
    }
  }

  checkForDefaultValue(props = this.props) {
    const { options = [], groupOptions = [], defaultValue, onChange = () => ({}) } = props
    const hasOptions = options.length > 0
    const hasGroupOptions = groupOptions.length > 0
    const hasDefault = !!defaultValue
    const shouldLoadDefault = !this.hasLoaded && (hasOptions || hasGroupOptions) && hasDefault
    let foundOption: IBtnSelectOption | undefined

    if (shouldLoadDefault) {
      if (hasOptions) {
        foundOption = options.find((o) => o.value === defaultValue)
      } else if (hasGroupOptions) {
        groupOptions.every((go) => {
          foundOption = go.nodes.find((o) => o.value === defaultValue)
          return foundOption ? false : true
        })
      }

      if (foundOption) {
        onChange(foundOption.value, foundOption.label || foundOption.value)
      }

      this.hasLoaded = true
    }
  }

  getLabelForValue(value?: string) {
    const { groupOptions, options, showAllCoachingFormOption } = this.props
    let selectedOption: IBtnSelectOption | undefined;

    if (!value) {
      if (showAllCoachingFormOption) {
        if (window.location.href.indexOf('coachingoverview') !== -1)
          return 'All Coaching Forms'
        else
          return 'All Comments'
      }
      return ''
    }

    if (options) {
      selectedOption = options.find((o) => o.value === value)
    } else if (groupOptions) {
      groupOptions.every((go) => {
        selectedOption = go.nodes.find((o) => o.value === value)

        return typeof selectedOption !== 'object'
      })
    }

    if (selectedOption) {
      return selectedOption.label || selectedOption.value
    }

    return ''
  }

  updateValue(e: React.ChangeEvent<HTMLSelectElement>) {
    const value = e.target.value
    const label = this.getLabelForValue(value)

    //stop erroneous scroll
    e.preventDefault();

    if (this.props.onChange) {
      this.props.onChange(value, label);
    }

    if (this.props.onClear && value === '') {
      this.props.onClear()
    }
  }

  render() {
    const { header, options, clearable = false, groupOptions, persistLabel = false, hideSelectedValue = false, useMobileMode = false, showSpinner = false } = this.props
    const { value: selectValue = '', clearLabel = 'Clear', color = 'light', disableBoldHeader = false } = this.props
    const hasSelectValue = selectValue !== ''
    const selectedValueLabel = this.getLabelForValue(selectValue)
    const hasSelectedValueLabel = !!selectedValueLabel
    const showPlaceholder = useMobileMode ? !hasSelectedValueLabel : (!hasSelectValue || persistLabel || hideSelectedValue)
    const showColon = showPlaceholder && !!hasSelectedValueLabel

    return (
      <span className="btn-select-container">
        {useMobileMode &&
          <h5>{header}</h5>
        }
        <Button color={color} className={`bl-btn bl-btn-select ${showSpinner ? 'spin-icon' : ''}`}
          disabled={this.props.disabled}>
          {showPlaceholder &&
            <>
              {disableBoldHeader ?
                <span>{header}</span>
                :
                <b className="fw-600">{header}</b>
              }
              {showColon && ': '}
            </>
          }
          {selectedValueLabel}
        </Button>
        <select className="browser-default btn-select-select"
          disabled={this.props.disabled}
          value={selectValue}
          autoFocus={false}
          onClick={(e) => e.preventDefault()}
          onChange={(e) => this.updateValue(e)}>
          {clearable &&
            <>
              <option value="">{clearLabel}</option>
              <option disabled>──────────</option>
            </>
          }
          {!hasSelectedValueLabel && !clearable &&
            <>
              <option value="" disabled>Nothing Selected</option>
              <option disabled>──────────</option>
            </>
          }
          {options && options.map(({ value, label = value, nodes = [] }) =>
            <option value={value} key={value}>{label}{nodes && nodes.length > 0 ? ' + ' : ''}</option>
          )}
          {groupOptions && groupOptions.map((gOption) =>
            <optgroup label={gOption.label} key={gOption.label}>
              {gOption.nodes.map(({ value, label = value }) =>
                <option value={value} key={value}>{label}</option>
              )}
            </optgroup>
          )}
        </select>
      </span>
    )
  }
}
